import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ReferenceDataService } from '../../../../lib/services/reference-data.service';
import { FormApplication } from '../../models/form-application.model';
import { MortgageClubDto } from '../../models/mortgage-club-dto.model';
import { MortgageClubsDto } from '../../models/mortgage-clubs-dto.model';
import { ApplicationFormStore } from '../../services/application-form-store';
import { ReferenceDataLabels } from './../../../../lib/constants/reference-data-labels';
import { ReferenceDataOptionLists } from './../../../../lib/constants/reference-data-option-lists';

@Component({
  selector: 'boi-mortgage-clubs',
  templateUrl: './mortgage-clubs.component.html',
  styleUrls: ['./mortgage-clubs.component.scss']
})
export class MortgageClubsComponent implements OnInit {
  @Input() public application: FormApplication;
  @Input() public isFieldDisabled: boolean;
  public hasErrors: boolean;

  public referenceDataLabels = ReferenceDataLabels;
  public mortgageClubDataSource = [];

  private readonly referenceDataOptionLists = ReferenceDataOptionLists;
  private mortgageSubmittingOptions = [];
  private mortgageClubs = new Array<MortgageClubDto>();

  private readonly notViaMortgageClubOption = {
    Value: this.referenceDataService.getLocalizeLabel(this.referenceDataLabels.NotViaMortgageClub),
    Code: this.referenceDataOptionLists.AnswerTypeNo
  };
  private readonly mortgageClubNamePlaceholder = '[MortgageClubName]';

  constructor(
    private readonly applicationFormStore: ApplicationFormStore,
    private readonly referenceDataService: ReferenceDataService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    this.mortgageClubDataSource = [];
    this.updateMortgageClubs(this.applicationFormStore.mortgageClubs);
  }

  private updateMortgageClubs(agentClubs: MortgageClubsDto): void {
    this.mortgageSubmittingOptions = [this.notViaMortgageClubOption];
    if (agentClubs?.AllowMortgageClubs) {
      this.mortgageClubs = agentClubs.MortgageClubs;
      this.parseMortgageClubList(agentClubs);
    }

    this.mortgageClubDataSource = this.mortgageSubmittingOptions;
    this.setDefaultClubSelection(agentClubs);
    this.changeDetectorRef.detectChanges();
  }

  private parseMortgageClubList(agentClubs: MortgageClubsDto): void {
    const mortgageClubLabel = this.referenceDataService.getLocalizeLabel(this.referenceDataLabels.ViaMortgageClub);
    const allMortgageClubs = this.referenceDataService.getOptionListConfigItems(
      this.referenceDataOptionLists.MortgageClub
    );

    allMortgageClubs.forEach((mortgageClub) => {
      if (this.getMortgageClubWithCode(agentClubs.MortgageClubs, mortgageClub.Code)) {
        this.mortgageSubmittingOptions.push({
          Code: mortgageClub.Code,
          Value: mortgageClubLabel.replace(this.mortgageClubNamePlaceholder, mortgageClub.Value)
        });
      }
    });

    if (agentClubs.MortgageClubSelectionCode === ReferenceDataOptionLists.MortgageClubSelectionTypeMust) {
      this.mortgageSubmittingOptions.shift();
    }
  }

  private setDefaultClubSelection(agentClubs: MortgageClubsDto): void {
    if (this.application.Fee) {
      if (!agentClubs?.AllowMortgageClubs) {
        this.application.Fee.SubmitViaMortgageClubCode = this.mortgageSubmittingOptions[0].Code;
      } else {
        const isOnlyOneClubAvailable =
          agentClubs.MortgageClubs.length === 1 && this.application.Fee.SubmitViaMortgageClubCode === null;

        if (isOnlyOneClubAvailable) {
          this.application.Fee.SubmitViaMortgageClubCode =
            agentClubs.MortgageClubSelectionCode === ReferenceDataOptionLists.MortgageClubSelectionTypeMust
              ? this.mortgageSubmittingOptions[0].Code
              : this.mortgageSubmittingOptions[1].Code;

          const mortgageClub = this.getMortgageClubWithCode(
            this.mortgageClubs,
            this.application.Fee.SubmitViaMortgageClubCode
          );
          if (mortgageClub) {
            this.application.Fee.MortgageClubNumber = mortgageClub.Number;
          }
        }
      }
    }
  }

  private getMortgageClubWithCode(mortgageClubs: Array<MortgageClubDto>, code: string): MortgageClubDto {
    if (mortgageClubs) {
      return mortgageClubs.find((mortgageClub) => mortgageClub.Code === code);
    }
  }

  public onMortgageClubCodeChange(): void {
    if (this.application.Fee) {
      const mortgageClub = this.getMortgageClubWithCode(
        this.mortgageClubs,
        this.application.Fee.SubmitViaMortgageClubCode
      );
      this.application.Fee.MortgageClubNumber = mortgageClub ? mortgageClub.Number : undefined;
    }
  }
}
